import { render } from "./material.vue?vue&type=template&id=174c1d21&scoped=true"
import script from "./material.vue?vue&type=script&lang=js"
export * from "./material.vue?vue&type=script&lang=js"

import "./material.vue?vue&type=style&index=0&id=174c1d21&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-174c1d21"

export default script